module.exports = new __parcel__URL__("complete.870411f4.wav").toString();